<template>
  <div class="container">
    <div>{{ round( data.steerAngle, 2) }}<span>°</span></div>

    <div class="steerAngle">
      <el-progress
        :style="{
          transform: `scaleX(${data.steerAngle >= 0 ? -1 : 1})`,
        }"
        type="circle"
        :percentage="Math.abs(data.steerAngle ? data.steerAngle : 0) / 3.6"
        :show-text="false"
      />
      <div
        class="svg"
        :style="{
          transform: `translate(-50%, -50%) translate3d(0,0,0) rotate(${
            -1 * data.steerAngle
          }deg)`,
        }"
      >
        <img
          class="wheel-img"
          src="@/assets/images/steering-wheel.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent,watch,reactive,ref  } from 'vue';
import { round } from 'lodash';
import { useFrameDataStore } from "@/store/frameDataStore";

export default defineComponent({
  name: 'SteerAngle',
  components: {},
  setup() {
    let data = ref({});
    let frameDataStore = useFrameDataStore();
    watch(() => frameDataStore.currentData, (e) => {
      if (e?.vehicleData) {
        data.value.steerAngle =  ((e.vehicleData.vehicle?.steerAngle * 180) / Math.PI).toFixed(2) * 10    
      }
    })
    return {
      data,
      round,
    };
  },
});
</script>
<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 13px;
  text-align: center;
  flex: 1;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  position: relative;

  .steerAngle {
    width: 112px;
    height: 112px;
    position: absolute;
    top: 25px;

    .svg {
      transition: all 0.6s;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 102px;
      height: 102px;
      transform-origin: 50% 50%;
      transform: translate(-50%, -50%);

      &::before {
        content: '';
        position: absolute;
        top: -4px;
        left: 50%;
        transform: translateX(-50%);
        height: 6px;
        width: 6px;
        background: #89ff3c;
        border-radius: 50%;
      }
    }
    :deep(.el-progress) {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
    :deep(.el-progress-circle) {
      width: 112px !important;
      height: 112px !important;
    }
    :deep(.el-progress-circle__track) {
      display: none;
    }
  }
}

.wheel-img {
  width: 102px;
  height: 102px;
}
</style>
